import CopyToClipboard from '../../../common/copyToClipboard';

const PaymentLink = ({ paymentLink }) => {
   
    return (
        <div className="w-100 text-center">
            <h3>Payment Link</h3>
            <a style={{textDecoration: "none", fontSize: "18px"}} href={paymentLink}>{paymentLink.substr(0, 40)} {paymentLink.length > 40 ? '...' : ''}</a>
            <CopyToClipboard textToCopy={paymentLink} />
        </div>
    )
}

export default PaymentLink